import '@virtualstate/navigation/polyfill'

/**
 * @function
 * @description An attempt to make the content not jump around on the screen while a page navigation is running
 */
export const fixatePageOnNavigation = ({ top = '0px' } = {}) => {
  /**
   * polyfill: @virtualstate/navigation
   */

  if (!window?.navigation) return
  window?.navigation.addEventListener('navigate', e => {
    const scrollY = window?.scrollY
    console.log(e)

    const { pathname } = new URL(e.destination.url)

    // bail if the new page is the old page (page load or changing query params)
    // EXCEPT for when the window.forceNavigationRefresh is set to true..
    // Bail if not a forced refresh, same pathname, or opening in a new tab/window
    if (
      !window?.forceNavigationRefresh &&
      window?.location.pathname === pathname
    ) {
      return
    }
    // If navigation is to a new tab/window (target is set), do nothing
    if (!e.destination.sameDocument) {
      console.log('Not same document, bail')
      return
    }

    const container = document.querySelector('main')

    // place the old page in the place it was,
    // so it's safe to scroll to the top
    container.style.position = 'fixed'
    container.style.width = '100vw'
    container.style.left = '0'
    container.style.top = `calc(-${scrollY}px + ${top})`

    // reset
    window.forceNavigationRefresh = false
  })
}

export const dolphin = () =>
  console.log(`%c Palefire - v2`, 'color: dodgerblue; font-family: "Menlo"')

export const formatMoney = amount => {
  let decimalPlaces = 2
  return new Intl.NumberFormat(window.Shopify.locale, {
    style: 'currency',
    currency: window.Shopify.currency.active,
    minimumFractionDigits: decimalPlaces,
    maximumFractionDigits: decimalPlaces,
  }).format(amount / 100)
}

export const getBreakpoint = size => {
  // Tailwind's default breakpoints
  const breakpoints = {
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280,
    '2xl': 1536,
  }
  return breakpoints[size] || null
}

export const debounce = (callback, wait) => {
  let timeoutId = null
  return (...args) => {
    window.clearTimeout(timeoutId)
    timeoutId = window.setTimeout(() => {
      callback.apply(null, args)
    }, wait)
  }
}
